import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'

import styles from './InactivePanel.module.scss'

function InactivePanel({ guestCount, onEnable, hideEnableButton = false }) {
  return (
    <div className={styles.inactivePanel}>
      <div className={styles.title}>This follow up is inactive</div>
      <div className={styles.description}>
        Enable to reach {guestCount.toLocaleString()} guests who haven't made a booking
      </div>
      {!hideEnableButton && (
        <PrimaryBigButton className={styles.enableButton} onClick={onEnable}>
          Enable follow up
        </PrimaryBigButton>
      )}
    </div>
  )
}

export default InactivePanel
